import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';

export default InjectedStyledComponent('span', 'dropdownMenu', ['menuItem']);